// Module
var code = `<div data-bind="compose: { model: usingExternalContext ? null : context }, visible: !usingExternalContext"></div>
<div class="shard-aware-container" data-bind="css: { pinned: context.pinned }, compose: { model: child, activationData: activationData, activate: false }, visible: child">
</div>
`;
// Exports
export default code;